/** @fileoverview Barrel for the student final self-assessment drawer. */

export { StudentFinalAssessmentDrawer } from './StudentFinalAssessmentDrawer'
